module.exports = __webpack_public_path__ + "img/syukyaku-sytem-ira004sp.f1f5f4ab.png";